import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
  formatTimezoneThenStraight1,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import UREstats from "./UREstats";
import AddLeadForm from "../../lead-management/AddLeadForm";
import LeadFollowupV1 from "../../lead-management/followup/LeadFollowupV1";
import { CheckCircleIcon, CrossCircleIcon, CallIcon } from "../../../images/icons/icons";
import LeadJourney from "../../lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../../lead-management/lms-v2/lms-payment-links/ClickToCall";

const UREdetails = ({
  tbData,
  tbPagination,
  isPage,
  setIsPage,
  setSelectedTab,
  clickedCard,
  calStatsCard,
  is_recurring,
  userInfoData,
  callFunction,
}) => {
  const { ureDetailsLoading } = useSelector((state) => state.api);
  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    partialDetails: [],
    rowData: null,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const handleTabChange = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  const tbColumns = [
    {
      dataField: "is_btn_enabled",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.is_btn_enabled ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.is_btn_enabled ? 1 : 0.5,
              }}
              onClick={() =>
                row?.is_btn_enabled &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  rowData: row,
                  cardType: "add-to-lead",
                }))
              }
              disabled={!row?.is_btn_enabled}
            >
              Add To LMS
            </button>
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.added_to_lead ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.added_to_lead ? 1 : 0.5,
              }}
              onClick={() =>
                row?.added_to_lead &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  rowData: row,
                  // cardType: "follow-up",
                  cardType: "view-lead-journey",
                }))
              }
              disabled={!row?.added_to_lead}
            >
              View Lead
            </button>
          </div>
        );
      },
    },
    {
      dataField: "added_to_lead",
      text: "Added To Lead",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.added_to_lead ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "user info",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "payment_location",
      text: "Payment Location",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_location ? row.payment_location : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "experience_level",
      text: "Experience Level",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.experience_level || "NA"}</span>;
      },
    },
    {
      dataField: "last_checkin",
      text: "Last Check-in",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.last_checkin || "NA"}
            {row?.checkin_time && (
              <>
                <br />
                <small>{row?.checkin_time}</small>
              </>
            )}
            {row?.last_checkin_days_ago && (
              <>
                <br />
                <small style={{ color: "#666" }}>
                  {row.last_checkin_days_ago?.replace(/_/g, " ")}
                </small>
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            <small style={{ textTransform: "initial", color: "gray" }}>
              {row?.gym_id || ""}
            </small>
            <br />
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "plan",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150" style={{ lineHeight: "31px" }}>
            {row?.type?.replace(/_/g, " ") || "NA"}
            <br />({row?.plan_name?.replace(/_/g, " ") || ""})
            <br />
            <small
              style={{
                padding: "10px",
                borderRadius: "4px",
                color: "#fff",
                backgroundColor: row?.subs_reference_id ? "#0F67B1" : "#36BA98",
              }}
            >
              {row?.subs_reference_id ? "Recurring" : "Non Recurring"}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (_, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "plan_name",
    //   text: "plan name",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.plan_name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  cardType: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "start_date",
    //   text: "Start/Expire Date",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data minWidth100"
    //         style={{ textDecoration: "underline" }}
    //       >
    //         {row?.start_date
    //           ? formatTimezoneThenStraight1(row.start_date)
    //           : "-"}
    //         <br />
    //         {row?.expire_date
    //           ? formatTimezoneThenStraight1(row.expire_date)
    //           : "-"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const isActive = row?.status === "active";

        return (
          <div className="flex-k">
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "sub_added_by",
      text: "Sub Added By",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.sub_added_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.sub_added_by_mobile || ""}
              <br />
              {row?.sub_added_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  cardType: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.cardType === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.cardType === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.cardType === "add-to-lead" || modValues.cardType === "click-to-call" ? null : modValues.cardType === "view-lead-journey" ? (
            <ModalHeadAndClose
              title={`Lead Details - ${modValues.rowData?.user_name || ""}`}
              onClose={closeModal}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.cardType === "partial_details"
                  ? "Partial Details"
                  : ""
              }`}
              onClose={closeModal}
            />
          )}

          {modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : modValues.cardType === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() => callFunction()}
              rowData={modValues.rowData}
              isURE={true}
              ureCard={
                clickedCard === "total_expiry"
                  ? "expiring"
                  : clickedCard === "total_unpaid"
                  ? "unpaid"
                  : clickedCard === "total_renewals" ||
                    clickedCard === "total_past_renewals"
                  ? "renewal"
                  : clickedCard
              }
            />
          ) : modValues.cardType === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              // callFunction={callFunction}
              closeFollowupModal={closeModal}
            />
          ) : modValues.cardType === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.cardType === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={closeModal}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      {clickedCard === "total_renewals" ? (
        <div className="ure-sr-or mt30">
          <Tabs onSelect={handleTabChange}>
            <TabList>
              <Tab>All Renewal</Tab>
              <Tab>Same Day Renewal</Tab>
              <Tab>Advance Renewal (Renewal From Other Day)</Tab>
            </TabList>

            {ureDetailsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <TabPanel>
                  <UREstats
                    calStatsCard={calStatsCard}
                    is_recurring={is_recurring}
                  />

                  <div className="fullWidthFlexCenter overflowAuto separatedTable">
                    <PaymentLinkTable
                      tableData={tbData}
                      tableColumns={tbColumns}
                      tablePagination={tbPagination}
                      isPage={isPage}
                      setIsPage={(value) => setIsPage(value)}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <UREstats
                    calStatsCard={calStatsCard}
                    is_recurring={is_recurring}
                  />

                  <div className="fullWidthFlexCenter overflowAuto separatedTable">
                    <PaymentLinkTable
                      tableData={tbData}
                      tableColumns={tbColumns}
                      tablePagination={tbPagination}
                      isPage={isPage}
                      setIsPage={(value) => setIsPage(value)}
                    />
                  </div>
                </TabPanel>
                <TabPanel>
                  <UREstats
                    calStatsCard={calStatsCard}
                    is_recurring={is_recurring}
                  />

                  <div className="fullWidthFlexCenter overflowAuto separatedTable">
                    <PaymentLinkTable
                      tableData={tbData}
                      tableColumns={tbColumns}
                      tablePagination={tbPagination}
                      isPage={isPage}
                      setIsPage={(value) => setIsPage(value)}
                    />
                  </div>
                </TabPanel>
              </>
            )}
          </Tabs>
        </div>
      ) : (
        <>
          {ureDetailsLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              <UREstats
                calStatsCard={calStatsCard}
                is_recurring={is_recurring}
              />

              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                <PaymentLinkTable
                  tableData={tbData}
                  tableColumns={tbColumns}
                  tablePagination={tbPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default UREdetails;
